/**
 * area-model.js
 *
 * 概述:
 * 地域信息API
 *
 * API:
 * 1.查询地域信息   queryAreaInfo
 * @author Qiutm 2018/4/18
 */
import axios from 'axios'
import setConfig from '@/config/axios-config'
setConfig(axios)

// 查询地域信息
export const queryAreaInfo = (data = {'provinceId': '', 'cityId': '', 'regionId': ''}) => {
  let param = 'app=getArea&flag=get&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios({
    method: 'POST',
    url: '/InfoServer/base/area.jsp',
    // TODO 本地测试用 /BaseInfoWeb/action/base/area.jsp
    // url: '/BaseInfoWeb/action/base/area.jsp',
    data: param,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}



// WEBPACK FOOTER //
// ./src/model/area-model.js